import { Component, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-availability-delete-confirm-dialog",
  templateUrl: "./availability-delete-confirm-dialog.component.html",
  styleUrls: ["./availability-delete-confirm-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class AvailabilityDeleteConfirmDialogComponent {
  dialogRef =
    inject<MatDialogRef<AvailabilityDeleteConfirmDialogComponent>>(
      MatDialogRef
    );

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close({ deleted: true });
  }
}
